export interface SupplierData {
  id: string
  name: string
  tier: number
  category: string
  region: string
  address: string
  lat: number
  lng: number
  status: 'On Schedule' | 'Delayed' | 'At Risk'
  connections?: string[]
  metrics?: {
    onTimeDelivery: number
    qualityRating: number
    riskScore: number
    leadTime: number
  }
}
// Generate mock supplier data
export const mockSupplierData: SupplierData[] = [
  // Original North American suppliers
  {
    id: 'S001',
    name: 'Acme Electronics',
    tier: 1,
    category: 'Electronics',
    region: 'North America',
    address: 'Chicago, IL',
    lat: 41.8781,
    lng: -87.6298,
    status: 'On Schedule',
    connections: ['S004', 'S005', 'S006'],
    metrics: {
      onTimeDelivery: 94,
      qualityRating: 92,
      riskScore: 12,
      leadTime: 10,
    },
  },
  {
    id: 'S002',
    name: 'Global Components',
    tier: 1,
    category: 'Components',
    region: 'Europe',
    address: 'Munich, Germany',
    lat: 48.1351,
    lng: 11.582,
    status: 'Delayed',
    connections: ['S007', 'S008', 'E001', 'E003'],
    metrics: {
      onTimeDelivery: 82,
      qualityRating: 88,
      riskScore: 28,
      leadTime: 15,
    },
  },
  {
    id: 'S003',
    name: 'Pacific Materials',
    tier: 1,
    category: 'Raw Materials',
    region: 'Asia',
    address: 'Tokyo, Japan',
    lat: 35.6762,
    lng: 139.6503,
    status: 'On Schedule',
    connections: ['S009', 'S010'],
    metrics: {
      onTimeDelivery: 96,
      qualityRating: 95,
      riskScore: 8,
      leadTime: 12,
    },
  },
  {
    id: 'S004',
    name: 'American Circuits',
    tier: 2,
    category: 'Electronics',
    region: 'North America',
    address: 'Austin, TX',
    lat: 30.2672,
    lng: -97.7431,
    status: 'On Schedule',
    connections: ['S011', 'S012'],
  },
  {
    id: 'S005',
    name: 'Tech Solutions',
    tier: 2,
    category: 'Electronics',
    region: 'North America',
    address: 'San Jose, CA',
    lat: 37.3382,
    lng: -121.8863,
    status: 'At Risk',
    connections: ['S013'],
  },
  {
    id: 'S006',
    name: 'Precision Parts',
    tier: 2,
    category: 'Components',
    region: 'North America',
    address: 'Detroit, MI',
    lat: 42.3314,
    lng: -83.0458,
    status: 'On Schedule',
    connections: ['S014'],
  },
  {
    id: 'S007',
    name: 'Euro Mechanics',
    tier: 2,
    category: 'Components',
    region: 'Europe',
    address: 'Stuttgart, Germany',
    lat: 48.7758,
    lng: 9.1829,
    status: 'Delayed',
    connections: ['S015', 'S016', 'E005', 'E008'],
  },
  {
    id: 'S008',
    name: 'Nordic Assembly',
    tier: 2,
    category: 'Components',
    region: 'Europe',
    address: 'Stockholm, Sweden',
    lat: 59.3293,
    lng: 18.0686,
    status: 'On Schedule',
    connections: ['S017', 'E012', 'E014'],
  },
  {
    id: 'S009',
    name: 'East Asia Manufacturing',
    tier: 2,
    category: 'Raw Materials',
    region: 'Asia',
    address: 'Seoul, South Korea',
    lat: 37.5665,
    lng: 126.978,
    status: 'On Schedule',
    connections: ['S018', 'S019'],
  },
  {
    id: 'S010',
    name: 'China Resources',
    tier: 2,
    category: 'Raw Materials',
    region: 'Asia',
    address: 'Shanghai, China',
    lat: 31.2304,
    lng: 121.4737,
    status: 'Delayed',
    connections: ['S020'],
  },
  {
    id: 'S011',
    name: 'Micro Electronics',
    tier: 3,
    category: 'Electronics',
    region: 'North America',
    address: 'Boston, MA',
    lat: 42.3601,
    lng: -71.0589,
    status: 'On Schedule',
  },
  {
    id: 'S012',
    name: 'Circuit Innovations',
    tier: 3,
    category: 'Electronics',
    region: 'North America',
    address: 'Raleigh, NC',
    lat: 35.7796,
    lng: -78.6382,
    status: 'On Schedule',
  },
  {
    id: 'S013',
    name: 'Silicon Valley Chips',
    tier: 3,
    category: 'Electronics',
    region: 'North America',
    address: 'Palo Alto, CA',
    lat: 37.4419,
    lng: -122.143,
    status: 'At Risk',
  },
  {
    id: 'S014',
    name: 'Automotive Specialists',
    tier: 3,
    category: 'Components',
    region: 'North America',
    address: 'Cleveland, OH',
    lat: 41.4993,
    lng: -81.6944,
    status: 'On Schedule',
  },
  {
    id: 'S015',
    name: 'German Precision',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Frankfurt, Germany',
    lat: 50.1109,
    lng: 8.6821,
    status: 'Delayed',
  },
  {
    id: 'S016',
    name: 'Italian Design',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Milan, Italy',
    lat: 45.4642,
    lng: 9.19,
    status: 'On Schedule',
  },
  {
    id: 'S017',
    name: 'Scandinavian Quality',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Copenhagen, Denmark',
    lat: 55.6761,
    lng: 12.5683,
    status: 'On Schedule',
  },
  {
    id: 'S018',
    name: 'Korean Steel',
    tier: 3,
    category: 'Raw Materials',
    region: 'Asia',
    address: 'Busan, South Korea',
    lat: 35.1796,
    lng: 129.0756,
    status: 'On Schedule',
  },
  {
    id: 'S019',
    name: 'Taiwan Semiconductors',
    tier: 3,
    category: 'Electronics',
    region: 'Asia',
    address: 'Taipei, Taiwan',
    lat: 25.033,
    lng: 121.5654,
    status: 'On Schedule',
  },
  {
    id: 'S020',
    name: 'China Metals',
    tier: 3,
    category: 'Raw Materials',
    region: 'Asia',
    address: 'Shenzhen, China',
    lat: 22.5431,
    lng: 114.0579,
    status: 'At Risk',
  },
  // New European Suppliers - Tier 1
  {
    id: 'E001',
    name: 'Paris Electronics',
    tier: 1,
    category: 'Electronics',
    region: 'Europe',
    address: 'Paris, France',
    lat: 48.8566,
    lng: 2.3522,
    status: 'On Schedule',
    connections: ['E002', 'E004', 'E006'],
    metrics: {
      onTimeDelivery: 91,
      qualityRating: 89,
      riskScore: 15,
      leadTime: 14,
    },
  },
  {
    id: 'E002',
    name: 'London Systems',
    tier: 2,
    category: 'Electronics',
    region: 'Europe',
    address: 'London, UK',
    lat: 51.5074,
    lng: -0.1278,
    status: 'Delayed',
    connections: ['E015', 'E016', 'E017'],
  },
  {
    id: 'E003',
    name: 'Berlin Manufacturing',
    tier: 1,
    category: 'Components',
    region: 'Europe',
    address: 'Berlin, Germany',
    lat: 52.52,
    lng: 13.405,
    status: 'On Schedule',
    connections: ['E007', 'E009', 'E011'],
    metrics: {
      onTimeDelivery: 93,
      qualityRating: 94,
      riskScore: 10,
      leadTime: 12,
    },
  },
  {
    id: 'E004',
    name: 'Madrid Components',
    tier: 2,
    category: 'Components',
    region: 'Europe',
    address: 'Madrid, Spain',
    lat: 40.4168,
    lng: -3.7038,
    status: 'On Schedule',
    connections: ['E018', 'E019'],
  },
  {
    id: 'E005',
    name: 'Rome Precision',
    tier: 2,
    category: 'Components',
    region: 'Europe',
    address: 'Rome, Italy',
    lat: 41.9028,
    lng: 12.4964,
    status: 'At Risk',
    connections: ['E020', 'E021'],
  },
  {
    id: 'E006',
    name: 'Amsterdam Logistics',
    tier: 2,
    category: 'Packaging',
    region: 'Europe',
    address: 'Amsterdam, Netherlands',
    lat: 52.3676,
    lng: 4.9041,
    status: 'On Schedule',
    connections: ['E022', 'E023'],
  },
  {
    id: 'E007',
    name: 'Brussels Electronics',
    tier: 2,
    category: 'Electronics',
    region: 'Europe',
    address: 'Brussels, Belgium',
    lat: 50.8503,
    lng: 4.3517,
    status: 'Delayed',
    connections: ['E024', 'E025'],
  },
  {
    id: 'E008',
    name: 'Vienna Precision',
    tier: 2,
    category: 'Components',
    region: 'Europe',
    address: 'Vienna, Austria',
    lat: 48.2082,
    lng: 16.3738,
    status: 'On Schedule',
    connections: ['E026', 'E027'],
  },
  {
    id: 'E009',
    name: 'Zurich Technologies',
    tier: 2,
    category: 'Electronics',
    region: 'Europe',
    address: 'Zurich, Switzerland',
    lat: 47.3769,
    lng: 8.5417,
    status: 'On Schedule',
    connections: ['E028', 'E029'],
  },
  {
    id: 'E010',
    name: 'Barcelona Systems',
    tier: 1,
    category: 'Electronics',
    region: 'Europe',
    address: 'Barcelona, Spain',
    lat: 41.3851,
    lng: 2.1734,
    status: 'On Schedule',
    connections: ['E030', 'E031', 'E032'],
    metrics: {
      onTimeDelivery: 89,
      qualityRating: 91,
      riskScore: 18,
      leadTime: 15,
    },
  },
  {
    id: 'E011',
    name: 'Warsaw Manufacturing',
    tier: 2,
    category: 'Raw Materials',
    region: 'Europe',
    address: 'Warsaw, Poland',
    lat: 52.2297,
    lng: 21.0122,
    status: 'Delayed',
    connections: ['E033', 'E034'],
  },
  {
    id: 'E012',
    name: 'Prague Components',
    tier: 2,
    category: 'Components',
    region: 'Europe',
    address: 'Prague, Czech Republic',
    lat: 50.0755,
    lng: 14.4378,
    status: 'On Schedule',
    connections: ['E035', 'E036'],
  },
  {
    id: 'E013',
    name: 'Budapest Electronics',
    tier: 1,
    category: 'Electronics',
    region: 'Europe',
    address: 'Budapest, Hungary',
    lat: 47.4979,
    lng: 19.0402,
    status: 'On Schedule',
    connections: ['E037', 'E038', 'E039'],
    metrics: {
      onTimeDelivery: 87,
      qualityRating: 86,
      riskScore: 22,
      leadTime: 18,
    },
  },
  {
    id: 'E014',
    name: 'Oslo Precision',
    tier: 2,
    category: 'Components',
    region: 'Europe',
    address: 'Oslo, Norway',
    lat: 59.9139,
    lng: 10.7522,
    status: 'On Schedule',
    connections: ['E040', 'E041'],
  },
  // Tier 3 European Suppliers
  {
    id: 'E015',
    name: 'Manchester Circuits',
    tier: 3,
    category: 'Electronics',
    region: 'Europe',
    address: 'Manchester, UK',
    lat: 53.4808,
    lng: -2.2426,
    status: 'On Schedule',
  },
  {
    id: 'E016',
    name: 'Birmingham Parts',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Birmingham, UK',
    lat: 52.4862,
    lng: -1.8904,
    status: 'Delayed',
  },
  {
    id: 'E017',
    name: 'Glasgow Electronics',
    tier: 3,
    category: 'Electronics',
    region: 'Europe',
    address: 'Glasgow, UK',
    lat: 55.8642,
    lng: -4.2518,
    status: 'On Schedule',
  },
  {
    id: 'E018',
    name: 'Valencia Components',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Valencia, Spain',
    lat: 39.4699,
    lng: -0.3763,
    status: 'On Schedule',
  },
  {
    id: 'E019',
    name: 'Seville Manufacturing',
    tier: 3,
    category: 'Raw Materials',
    region: 'Europe',
    address: 'Seville, Spain',
    lat: 37.3891,
    lng: -5.9845,
    status: 'At Risk',
  },
  {
    id: 'E020',
    name: 'Naples Precision',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Naples, Italy',
    lat: 40.8518,
    lng: 14.2681,
    status: 'Delayed',
  },
  {
    id: 'E021',
    name: 'Turin Automotive',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Turin, Italy',
    lat: 45.0703,
    lng: 7.6869,
    status: 'On Schedule',
  },
  {
    id: 'E022',
    name: 'Rotterdam Logistics',
    tier: 3,
    category: 'Packaging',
    region: 'Europe',
    address: 'Rotterdam, Netherlands',
    lat: 51.9244,
    lng: 4.4777,
    status: 'On Schedule',
  },
  {
    id: 'E023',
    name: 'Utrecht Electronics',
    tier: 3,
    category: 'Electronics',
    region: 'Europe',
    address: 'Utrecht, Netherlands',
    lat: 52.0907,
    lng: 5.1214,
    status: 'On Schedule',
  },
  {
    id: 'E024',
    name: 'Antwerp Components',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Antwerp, Belgium',
    lat: 51.2194,
    lng: 4.4025,
    status: 'Delayed',
  },
  {
    id: 'E025',
    name: 'Ghent Manufacturing',
    tier: 3,
    category: 'Raw Materials',
    region: 'Europe',
    address: 'Ghent, Belgium',
    lat: 51.0543,
    lng: 3.7174,
    status: 'On Schedule',
  },
  {
    id: 'E026',
    name: 'Salzburg Precision',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Salzburg, Austria',
    lat: 47.8095,
    lng: 13.055,
    status: 'On Schedule',
  },
  {
    id: 'E027',
    name: 'Graz Electronics',
    tier: 3,
    category: 'Electronics',
    region: 'Europe',
    address: 'Graz, Austria',
    lat: 47.0707,
    lng: 15.4395,
    status: 'At Risk',
  },
  {
    id: 'E028',
    name: 'Geneva Precision',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Geneva, Switzerland',
    lat: 46.2044,
    lng: 6.1432,
    status: 'On Schedule',
  },
  {
    id: 'E029',
    name: 'Basel Electronics',
    tier: 3,
    category: 'Electronics',
    region: 'Europe',
    address: 'Basel, Switzerland',
    lat: 47.5596,
    lng: 7.5886,
    status: 'On Schedule',
  },
  {
    id: 'E030',
    name: 'Malaga Components',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Malaga, Spain',
    lat: 36.7213,
    lng: -4.4213,
    status: 'Delayed',
  },
  {
    id: 'E031',
    name: 'Bilbao Manufacturing',
    tier: 3,
    category: 'Raw Materials',
    region: 'Europe',
    address: 'Bilbao, Spain',
    lat: 43.263,
    lng: -2.935,
    status: 'On Schedule',
  },
  {
    id: 'E032',
    name: 'Zaragoza Electronics',
    tier: 3,
    category: 'Electronics',
    region: 'Europe',
    address: 'Zaragoza, Spain',
    lat: 41.6488,
    lng: -0.8891,
    status: 'On Schedule',
  },
  {
    id: 'E033',
    name: 'Krakow Components',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Krakow, Poland',
    lat: 50.0647,
    lng: 19.945,
    status: 'On Schedule',
  },
  {
    id: 'E034',
    name: 'Gdansk Manufacturing',
    tier: 3,
    category: 'Raw Materials',
    region: 'Europe',
    address: 'Gdansk, Poland',
    lat: 54.352,
    lng: 18.6466,
    status: 'At Risk',
  },
  {
    id: 'E035',
    name: 'Brno Electronics',
    tier: 3,
    category: 'Electronics',
    region: 'Europe',
    address: 'Brno, Czech Republic',
    lat: 49.1951,
    lng: 16.6068,
    status: 'On Schedule',
  },
  {
    id: 'E036',
    name: 'Ostrava Components',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Ostrava, Czech Republic',
    lat: 49.8209,
    lng: 18.2625,
    status: 'Delayed',
  },
  {
    id: 'E037',
    name: 'Debrecen Electronics',
    tier: 3,
    category: 'Electronics',
    region: 'Europe',
    address: 'Debrecen, Hungary',
    lat: 47.5316,
    lng: 21.6273,
    status: 'On Schedule',
  },
  {
    id: 'E038',
    name: 'Szeged Components',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Szeged, Hungary',
    lat: 46.253,
    lng: 20.1414,
    status: 'On Schedule',
  },
  {
    id: 'E039',
    name: 'Miskolc Manufacturing',
    tier: 3,
    category: 'Raw Materials',
    region: 'Europe',
    address: 'Miskolc, Hungary',
    lat: 48.1035,
    lng: 20.7784,
    status: 'At Risk',
  },
  {
    id: 'E040',
    name: 'Bergen Components',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Bergen, Norway',
    lat: 60.3913,
    lng: 5.3221,
    status: 'On Schedule',
  },
  {
    id: 'E041',
    name: 'Trondheim Electronics',
    tier: 3,
    category: 'Electronics',
    region: 'Europe',
    address: 'Trondheim, Norway',
    lat: 63.4305,
    lng: 10.3951,
    status: 'Delayed',
  },
  // Additional European Tier 1 Suppliers
  {
    id: 'E042',
    name: 'Lyon Advanced Materials',
    tier: 1,
    category: 'Raw Materials',
    region: 'Europe',
    address: 'Lyon, France',
    lat: 45.764,
    lng: 4.8357,
    status: 'On Schedule',
    connections: ['E043', 'E044', 'E045'],
    metrics: {
      onTimeDelivery: 92,
      qualityRating: 90,
      riskScore: 14,
      leadTime: 13,
    },
  },
  {
    id: 'E043',
    name: 'Marseille Components',
    tier: 2,
    category: 'Components',
    region: 'Europe',
    address: 'Marseille, France',
    lat: 43.2965,
    lng: 5.3698,
    status: 'Delayed',
    connections: ['E046', 'E047'],
  },
  {
    id: 'E044',
    name: 'Bordeaux Electronics',
    tier: 2,
    category: 'Electronics',
    region: 'Europe',
    address: 'Bordeaux, France',
    lat: 44.8378,
    lng: -0.5792,
    status: 'On Schedule',
    connections: ['E048', 'E049'],
  },
  {
    id: 'E045',
    name: 'Toulouse Aerospace',
    tier: 2,
    category: 'Components',
    region: 'Europe',
    address: 'Toulouse, France',
    lat: 43.6047,
    lng: 1.4442,
    status: 'On Schedule',
    connections: ['E050', 'E051'],
  },
  {
    id: 'E046',
    name: 'Nice Precision',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Nice, France',
    lat: 43.7102,
    lng: 7.262,
    status: 'On Schedule',
  },
  {
    id: 'E047',
    name: 'Strasbourg Electronics',
    tier: 3,
    category: 'Electronics',
    region: 'Europe',
    address: 'Strasbourg, France',
    lat: 48.5734,
    lng: 7.7521,
    status: 'At Risk',
  },
  {
    id: 'E048',
    name: 'Lille Components',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Lille, France',
    lat: 50.6292,
    lng: 3.0573,
    status: 'On Schedule',
  },
  {
    id: 'E049',
    name: 'Nantes Manufacturing',
    tier: 3,
    category: 'Raw Materials',
    region: 'Europe',
    address: 'Nantes, France',
    lat: 47.2184,
    lng: -1.5536,
    status: 'Delayed',
  },
  {
    id: 'E050',
    name: 'Montpellier Electronics',
    tier: 3,
    category: 'Electronics',
    region: 'Europe',
    address: 'Montpellier, France',
    lat: 43.6108,
    lng: 3.8767,
    status: 'On Schedule',
  },
  {
    id: 'E051',
    name: 'Rennes Components',
    tier: 3,
    category: 'Components',
    region: 'Europe',
    address: 'Rennes, France',
    lat: 48.1173,
    lng: -1.6778,
    status: 'On Schedule',
  },
]
